import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useProductDetailContext } from '~/techstyle-shared/react-components';

import MemberModelContent from '../EnhancedMemberModelContent';
import MemberModelProvider from '../EnhancedMemberModelProvider';

const MemberModelWrapper = styled.div``;

export default function MemberModel({ product: productFromProps = null }) {
  const productDetailFromCtx = useProductDetailContext();
  const product = productFromProps || productDetailFromCtx.product;

  if (!product) {
    return null;
  }

  return (
    <MemberModelProvider>
      <MemberModelWrapper data-testid="member-model">
        <MemberModelContent />
      </MemberModelWrapper>
    </MemberModelProvider>
  );
}

MemberModel.propTypes = {
  product: PropTypes.object,
};
